import { getThemeColorHex } from '@jooxter/tailwind-config';

// same star as JxtStar (small), drawn in a 28x28 box centered on (14, 14)
const STAR_PATH =
  'M14.875 6.5625C14.7188 6.21875 14.375 6 14 6C13.5938 6 13.25 6.21875 13.0938 6.5625L11.0938 10.7188L6.59375 11.375C6.21875 11.4375 5.90625 11.6875 5.78125 12.0625C5.6875 12.4062 5.78125 12.8125 6.03125 13.0625L9.28125 16.2812L8.53125 20.8438C8.46875 21.2188 8.625 21.5938 8.9375 21.8125C9.25 22.0625 9.65625 22.0625 9.96875 21.9062L14 19.75L18 21.9062C18.3438 22.0625 18.75 22.0625 19.0625 21.8125C19.375 21.5938 19.5312 21.2188 19.4688 20.8438L18.6875 16.2812L21.9375 13.0625C22.2188 12.8125 22.3125 12.4062 22.1875 12.0625C22.0625 11.6875 21.75 11.4375 21.375 11.375L16.9062 10.7188L14.875 6.5625Z';
const STAR_CENTER = 14;
const STAR_WIDTH = 16;

/**
 * Small star badge drawn on the top-left of a resource picto
 * (top-right is reserved for the occupation badge).
 */
export const JxtFavoriteBadge = ({ x, y, size }: { x: number; y: number; size: number }) => {
  const pictoRadius = size / 2.3;
  const radius = pictoRadius / 2.3;
  const offset = pictoRadius * 0.8;
  const cx = x + size / 2 - offset;
  const cy = y + size / 2 - offset;
  const scale = (radius * 1.4) / STAR_WIDTH;

  return (
    <g data-testid="favorite-badge">
      <circle cx={cx} cy={cy} r={radius} fill="white" stroke={getThemeColorHex('orange100')} strokeWidth={radius / 6} />
      <path
        d={STAR_PATH}
        fill={getThemeColorHex('orange100')}
        transform={`translate(${cx}, ${cy}) scale(${scale}) translate(-${STAR_CENTER}, -${STAR_CENTER})`}
      />
    </g>
  );
};
